import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { availabilityShape, bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { bindAll } from '@bibliocommons/utils-react';
import { FORMAT_CHOOSER_MODAL } from 'app/constants/BibConstants';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibFormatChooser } from '@bibliocommons/analytics-event-composers';
import FormatChooserCapsule from './FormatChooserCapsule';
import MoreFormatsDropdown from './MoreFormatsDropdown';
import FormatChooserModal from './FormatChooserModal';

import './FormatChooser.scss';

const { composeFormatPickerSelectionEvent } = bibFormatChooser;

export class FormatChooser extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleOpen(e) {
    e.preventDefault();
    this.props.modalActions.openModal(FORMAT_CHOOSER_MODAL, { authRequired: false });
  }

  handleClose() {
    this.props.modalActions.closeModal(FORMAT_CHOOSER_MODAL);
  }

  renderMoreFormatsDropdown() {
    if (this.props.manifestations.size > 3) {
      return <MoreFormatsDropdown manifestations={this.props.manifestations.slice(3)} />;
    }

    return null;
  }

  renderMobile() {
    const { manifestations, realtimeAvailabilities, catalogBib, summary } = this.props;
    const mainBib = manifestations.find(manifestation => manifestation.get('id') === catalogBib.get('id'));
    const mainBibAvailability = realtimeAvailabilities.get(mainBib.get('id'), mainBib.get('availability'));
    const formatsCount = manifestations.size;
    const multipleManifestationsPresent = formatsCount > 1;

    return (
      <div className="format-chooser-capsule-mobile">
        <FormatChooserCapsule
          href={multipleManifestationsPresent ? '#format-chooser-modal' : undefined}
          handleClick={multipleManifestationsPresent ? this.handleOpen : undefined}
          isActive
          className="capsule-mobile"
          availability={mainBibAvailability}
          bib={mainBib}
          displayChevron={multipleManifestationsPresent}
          formatsCount={formatsCount}
        />
        <FormatChooserModal
          catalogBib={catalogBib}
          summary={summary}
          handleClose={this.handleClose}
          manifestations={manifestations}
          realtimeAvailabilities={realtimeAvailabilities}
        />
      </div>
    );
  }

  renderDesktop() {
    const { realtimeAvailabilities, catalogBib, editions } = this.props;

    const handleClick = manifestation => {
      sendAnalyticsEvents(composeFormatPickerSelectionEvent(manifestation.getIn(['briefInfo', 'format'])));
    };

    const renderCapsule = manifestation => {
      const isActive = manifestation.get('id') === catalogBib.get('id');
      const availability = realtimeAvailabilities.get(manifestation.get('id'), manifestation.get('availability'));

      return (
        <FormatChooserCapsule
          href={!isActive ? `/v2/record/${manifestation.get('id')}` : undefined}
          handleClick={!isActive ? () => handleClick(manifestation) : undefined}
          className="capsule-desktop"
          key={`format-chooser-capsule-desktop-${manifestation.get('id')}`}
          availability={availability}
          bib={manifestation}
          editions={editions}
          isActive={isActive}
        />
      );
    };

    return (
      <div className="format-chooser-capsule-desktop">
        {this.props.manifestations.slice(0, 3).map(renderCapsule)}
        {this.renderMoreFormatsDropdown()}
      </div>
    );
  }

  render() {
    return (
      <div className="cp-format-chooser">
        {this.renderDesktop()}
        {this.renderMobile()}
      </div>
    );
  }
}

FormatChooser.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  manifestations: ImmutablePropTypes.listOf(bibShape).isRequired,
  editions: ImmutablePropTypes.listOf(bibShape).isRequired,
  realtimeAvailabilities: ImmutablePropTypes.mapOf(availabilityShape).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  summary: ImmutablePropTypes.map.isRequired
};

export default FormatChooser;
